/** Exact read semantics verified in platform-settings/handler.py and settings/handler.py.
 * Presentation only: no scope mutation and no authority or write-policy change. */
export function scopePresentation(pathname:string) {
 const path=pathname.replace(/\/$/,'');
 if(['/administration/platform/registries','/administration/platform/environment-templates','/administration/platform/feature-flags'].includes(path))return {
  kind:'organisation' as const,label:'Organisation-wide',reason:'This shared platform configuration is not filtered by the browsing environment. Individual records retain their explicit targets.'};
 if(path==='/settings')return {kind:'personal' as const,label:'Personal',reason:'These settings belong to the signed-in user, independently of the browsing environment.'};
 return {kind:'environment' as const,label:'Environment',reason:null};
}
